import { Collapse, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import { CardType, QuestionDetailsFragment } from '../../../../graphql/gen/types';
import { colorPalette, spacings, TextSizesEnum } from '../../../../theme';
import { PlexTypography } from '../../../shared/primitives/PlexTypography';
import { NewAnswerButton } from '../../post_form/NewAnswerButton';
import { QuestionAnswer } from './Answer';

type Props = {
  question: QuestionDetailsFragment;
};

export function QuestionAnswers({ question }: Props): React.ReactElement {
  const classes = useStyles();
  const answers = (question.answers || []).filter((answer) => !answer.deleted);

  return (
    <div className={classes.root}>
      {question.type === CardType.Faq && (
        <div className={classes.header}>
          <PlexTypography
            className={classes.title}
            text={
              answers.length === 0
                ? 'No Answers yet.'
                : answers.some((answer) => answer.id === question.acceptedAnswer?.id)
                ? `Other Answers (${answers.length - 1})`
                : `Answers (${answers.length}) - No approved Answers`
            }
            size={TextSizesEnum.NormalPlus}
          />
          <NewAnswerButton question={question} />
        </div>
      )}
      {answers.map((answer) => (
        <Collapse key={answer.id} in={answer.id !== question.acceptedAnswer?.id}>
          <QuestionAnswer className={classes.answer} key={answer.id} answer={answer} question={question} />
        </Collapse>
      ))}
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: spacings.normal,
    marginTop: spacings.normal,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `${spacings.normal}px ${spacings.xxlarge}px`,
    backgroundColor: '#F7F7FB',
    borderTop: `1px solid ${colorPalette.gray._300}`,
    borderBottom: `1px solid ${colorPalette.gray._300}`,
  },
  title: {
    color: colorPalette.purpleGray._500,
  },
  answer: {
    backgroundColor: '#F7F7FB',
    marginTop: spacings.normal,
    marginBottom: 0,
  },
}));
